import React from 'react';
import PropTypes from 'prop-types';

import { Consumer } from './ThemeContext';

const ThemeClass = ({ children, color, style, dir, lang }) => {
    const layoutThemeClass = `layout--theme--${ style }--${ color }`;
    return children({themeClass: layoutThemeClass, dir: dir, lang: lang});
};
ThemeClass.propTypes = {
    children: PropTypes.func.isRequired,
    color: PropTypes.string,
    style: PropTypes.string,
};

const ContextThemeClass = (otherProps) =>
    <Consumer>
        {
            (themeState) => <ThemeClass {...{ ...themeState, ...otherProps }}/>
        }
    </Consumer>;

export { ContextThemeClass as ThemeClass };

